import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
	'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
	{
		variants: {
			variant: {
				default: 'border-transparent bg-gray-900 text-white',
				secondary: 'border-transparent bg-gray-100 text-gray-900',
				destructive: 'border-transparent bg-red-500 text-white',
				outline: 'text-gray-900',
				success: 'border-transparent bg-green-100 text-green-800',
				warning: 'border-transparent bg-yellow-100 text-yellow-800',
				info: 'border-transparent bg-blue-100 text-blue-800',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	}
);

function Badge({ className, variant, ...props }) {
	return (
		<div className={cn(badgeVariants({ variant }), className)} {...props} />
	);
}

export { Badge, badgeVariants };
